import React from 'react';
import { connect } from 'react-redux';
import { DisclaimerCard } from 'components/DisclaimerCard';
import './InfoPanels.scss';

const InfoPanels = ({ infoButtonActive }) => {
  if (!infoButtonActive) {
    return null;
  }

  return (
    <>
      {/* Disclaimer Panel - Left Side */}
      <div className="info-panel info-panel--left disclaimer-card-container">
        <DisclaimerCard />
      </div>

      {/* Project Info Panel - Right Side */}
      <div className="info-panel info-panel--right">
        <div className="info-panel__table">
          <div className="info-panel__row">
            <div className="info-panel__label">Project name</div>
            <div className="info-panel__value">
              HIGH-RISE MIXED-USE URBAN AREA
              <br /> THE WIN CITY
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Overview</div>
            <div className="info-panel__value">
              <p>
                13.1753 ha, 18 blocks <br />
                over 6,000 units
              </p>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Building density</div>
            <div className="info-panel__value">29.82%</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Healthcare and education
              <br /> land area
            </div>
            <div className="info-panel__value">
              19,267 m<sup>2</sup>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Green space area</div>
            <div className="info-panel__value">
              <div>
                26,055 m<sup>2</sup>
              </div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">Developer</div>
            <div className="info-panel__value">
              <div>Thang Loi Real Estate Group</div>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Joint venture
              <br />
              Investors
            </div>
            <div className="info-panel__value">
              Thang Loi Homes JSC <br /> An Cuong Wood JSC <br /> Central
              Construction JSC
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">
              Investor
              <br />
              General contractor
            </div>
            <div className="info-panel__value">
              <div>Central</div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">
              Investor
              <br />
              Interior solutions
            </div>
            <div className="info-panel__value">
              <div>An Cuong</div>
            </div>
          </div>
          <div className="info-panel__row">
            <div className="info-panel__label">
              Consultant <br /> Operations management
            </div>
            <div className="info-panel__value">
              <div>CBRE</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  infoButtonActive: state.iconButtons.infoButtonActive,
});

export default connect(mapStateToProps)(InfoPanels);
